module.exports = __webpack_public_path__ + "static/img/08.ee0f8f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/08.jpg
// module id = 403
// module chunks = 1